import { render, staticRenderFns } from "./LogoRow.vue?vue&type=template&id=44c2a742&scoped=true"
import script from "./LogoRow.vue?vue&type=script&lang=js"
export * from "./LogoRow.vue?vue&type=script&lang=js"
import style0 from "./LogoRow.vue?vue&type=style&index=0&id=44c2a742&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44c2a742",
  null
  
)

export default component.exports